<template>
  <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
    <!-- Search / Filter -->
    <div style="margin-bottom: 16px">
      <a-button type="primary" @click="handleAdd">添加标签</a-button>
    </div>

    <!-- 表格 -->
    <MyTable
      ref="table"
      :apiUrl="material_tag_index"
      :columns="columns"
      :rowKey="'id'"
    >
      <span slot="type" slot-scope="text">
        {{ typeLabel(text) }}
      </span>
      <span slot="is_goods" slot-scope="text">
        {{ text === 1 ? "是" : "否" }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button
          type="primary"
          size="small"
          style="margin-right: 10px"
          @click="handleEdit(record)"
          >编辑</a-button
        >
        <a-popconfirm title="确定要删除吗?" @confirm="handleDelete(record)">
          <a-button type="danger" size="small">删除</a-button>
        </a-popconfirm>
      </span>
    </MyTable>

    <!-- 模态框 -->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="标签名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入标签名称" />
        </a-form-model-item>
        <a-form-model-item label="类型" prop="type">
          <a-radio-group v-model="form.type">
            <a-radio :value="1">视频</a-radio>
            <a-radio :value="2">图片</a-radio>
            <a-radio :value="3">文案</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="是否关联商品" prop="is_goods">
          <a-radio-group v-model="form.is_goods">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort">
          <a-input-number v-model="form.sort" :min="0" style="width: 100%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import {
  material_tag_index,
  material_tag_add,
  material_tag_edit,
  material_tag_del,
} from "@/api/material";

export default {
  name: "MaterialTag",
  components: {
    MyTable,
  },
  data() {
    return {
      material_tag_index,
      visible: false,
      confirmLoading: false,
      modalTitle: "添加标签",
      form: {
        id: undefined,
        name: "",
        type: 1,
        is_goods: 0,
        sort: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
      },
      columns: [
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
        { title: "标签名称", dataIndex: "name" },
        {
          title: "类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        {
          title: "关联商品",
          dataIndex: "is_goods",
          scopedSlots: { customRender: "is_goods" },
        },
        { title: "排序", dataIndex: "sort" },
        { title: "创建时间", dataIndex: "create_at" },
        { title: "更新时间", dataIndex: "update_at" },
      ],
    };
  },
  methods: {
    typeLabel(v) {
      const n = Number(v);
      const map = { 1: "视频", 2: "图片", 3: "文案" };
      return map[n] ?? "";
    },
    handleAdd() {
      this.modalTitle = "添加标签";
      this.form = {
        name: "",
        type: 1,
        is_goods: 0,
        sort: 0,
      };
      this.visible = true;
    },
    handleEdit(record) {
      this.modalTitle = "编辑标签";
      this.form = { ...record };
      this.visible = true;
    },
    handleDelete(record) {
      material_tag_del({ id: record.id }).then(() => {
        this.$message.success("删除成功");
        this.$refs.table.getList();
      });
    },
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const api = this.form.id ? material_tag_edit : material_tag_add;
          api(this.form)
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "添加成功");
              this.visible = false;
              this.$refs.table.getList();
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>
